import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface NotaInterna {
  id: string;
  titulo: string;
  contenido: string;
  fecha: string;
  hora: string;
  usuario: string;
  created_at?: string;
  updated_at?: string;
}

export interface CreateNotaRequest {
  patient_id: number;
  titulo: string;
  contenido: string;
}

export interface UpdateNotaRequest {
  titulo?: string;
  contenido?: string;
}

@Injectable({ providedIn: 'root' })
export class PatientInternalNotesService {
  private apiUrl = `${environment.apiUrl}`;

  constructor(private http: HttpClient) {}

  getByPatient(patientId: number): Observable<NotaInterna[]> {
    return this.http.get<any>(`${this.apiUrl}/pacientes/${patientId}/notas-internas`)
      .pipe(
        map(response => response.data || []),
        catchError(this.handleError)
      );
  }

  create(data: CreateNotaRequest): Observable<NotaInterna> {
    return this.http.post<any>(`${this.apiUrl}/notas-internas`, data)
      .pipe(
        map(response => response.data),
        catchError(this.handleError)
      );
  }

  update(id: string, data: UpdateNotaRequest): Observable<NotaInterna> {
    return this.http.put<any>(`${this.apiUrl}/notas-internas/${id}`, data)
      .pipe(
        map(response => response.data),
        catchError(this.handleError)
      );
  }

  delete(id: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/notas-internas/${id}`)
      .pipe(
        map(response => response),
        catchError(this.handleError)
      );
  }

  private handleError(error: any): Observable<never> {
    let errorMessage = 'Ocurrió un error en el servidor';

    if (error.status === 422 && error.error?.errors) {
      const validationErrors = Object.entries(error.error.errors)
        .map(([field, messages]: [string, any]) => {
          const errorList = Array.isArray(messages) ? messages.join(', ') : messages;
          return `${field}: ${errorList}`;
        })
        .join('; ');
      errorMessage = `Errores de validación: ${validationErrors}`;
    } else if (error.error?.message) {
      errorMessage = error.error.message;
    } else if (error.status === 0) {
      errorMessage = 'No se pudo conectar con el servidor';
    } else if (error.status === 401) {
      errorMessage = 'Sesión expirada, por favor inicia sesión nuevamente';
    } else if (error.status === 404) {
      errorMessage = 'Recurso no encontrado';
    }

    console.error('[PatientInternalNotesService] Error:', errorMessage, error);
    return throwError(() => error);
  }
}
